import { useMutation } from '@tanstack/react-query'
import { getMyPoint } from '../../../service/point'

export const useMutateMyPoint = () => {
  return useMutation({
    mutationKey: ['mutate-my-point'],
    mutationFn: getMyPoint,
  })
}
